/* eslint-disable quotes */
/** On peut décomposer les routes par module**/
import Layout from "@/layout";

const locationRoutes = {
  path: "/locations",
  component: Layout,
  redirect: "/locations/provinces",
  name: "Locations",
  // alwaysShow: true,
  meta: {
    title: "locations",
    icon: "el-icon-location",
    permissions: ["manage province", "manage department", "manage municipality", "manage village"],
  },
  children: [
    {
      path: "provinces",
      component: () =>
        import(/* webpackChunkName: "provinces" */ "@/views/provinces/index"),
      name: "provinces",
      meta: { title: "provinces", icon: "el-icon-guide", permissions: ["manage province"] },
    },
    {
      path: "departments",
      component: () =>
        import(/* webpackChunkName: "departments" */ "@/views/departments/index"),
      name: "departments",
      meta: { title: "departments", icon: "department", permissions: ["manage department"] },
    },
    {
      path: "municipalities",
      component: () =>
        import(/* webpackChunkName: "municipalities" */ "@/views/municipalities/index"),
      name: "municipalities",
      meta: { title: "municipalities", icon: "el-icon-guide", permissions: ["manage municipality"] },
    },
    {
      path: "/villages",
      component: () =>
        import(/* webpackChunkName: "villages" */ "@/views/villages/index"),
      name: "villages",
      meta: { title: "villages", icon: "village", permissions: ["manage village"] },
    },
  ],
};

export default locationRoutes;
